import {
  all,
  call,
  put,
  takeLatest,
} from 'redux-saga/effects';

import { post } from '@dmi/shared/utils/request';

import {
  changeStep,
  forgotPasswordInitiateFailure,
  forgotPasswordInitiateSuccess,
  forgotPasswordVerifyFailure,
  forgotPasswordVerifySuccess,
} from './actions';
import {
  DEFAULT_FORGOT_PASSWORD_ERRORS,
  FORGOT_PASSWORD_ERROR_MESSAGE,
  FORGOT_PASSWORD_INITIATE,
  FORGOT_PASSWORD_VERIFY,
} from './constants';
import { parseReasonCodes } from '../Shared/helpers';

export function* forgotPasswordInitiateSaga({ baseUrl }, { payload }) {
  const { username } = payload;
  try {
    const endpoint = `${baseUrl}/register/password/init`;
    const { error } = yield call(post, endpoint, { username });
    if (error) {
      const { defaultForgotPasswordErrors } = DEFAULT_FORGOT_PASSWORD_ERRORS;
      const { reasons } = error;
      const {
        bannerError,
        noError,
        serviceError,
        ...validationErrors
      } = parseReasonCodes(reasons, defaultForgotPasswordErrors);
      const hasValidationErrors = Object.values(validationErrors).some((val) => !!val);
      if (bannerError.length || hasValidationErrors) {
        yield put(forgotPasswordInitiateFailure({ bannerError: bannerError[0], validationErrors }));
      } else if (noError) {
        yield put(forgotPasswordInitiateSuccess());
        yield put(changeStep(2, 'init'));
      } else {
        throw new Error('serviceError');
      }
    } else {
      yield put(forgotPasswordInitiateSuccess());
      yield put(changeStep(2, 'init'));
    }
  } catch (error) {
    yield put(forgotPasswordInitiateFailure({ error: FORGOT_PASSWORD_ERROR_MESSAGE }));
    yield put(changeStep(2, 'init'));
  }
}

export function* forgotPasswordVerifySaga({ baseUrl }, { payload }) {
  try {
    const endpoint = `${baseUrl}/register/password/verify`;
    const { error } = yield call(post, endpoint, payload);
    if (error) {
      const { defaultResetPasswordErrors } = DEFAULT_FORGOT_PASSWORD_ERRORS;
      const { reasons } = error;
      const {
        bannerError,
        noError,
        serviceError,
        ...validationErrors
      } = parseReasonCodes(reasons, defaultResetPasswordErrors);
      const hasValidationErrors = Object.values(validationErrors).some((val) => !!val);
      if (bannerError.length || hasValidationErrors) {
        yield put(forgotPasswordVerifyFailure({ bannerError: bannerError[0], validationErrors }));
      } else if (noError) {
        yield put(forgotPasswordVerifySuccess());
        yield put(changeStep(2, 'verify'));
      } else {
        throw new Error('serviceError');
      }
    } else {
      yield put(forgotPasswordVerifySuccess());
      yield put(changeStep(2, 'verify'));
    }
  } catch (error) {
    yield put(forgotPasswordVerifyFailure({ error: FORGOT_PASSWORD_ERROR_MESSAGE }));
    yield put(changeStep(2, 'verify'));
  }
}

export default (options) => function* rootSaga() {
  yield all([
    takeLatest(FORGOT_PASSWORD_INITIATE, forgotPasswordInitiateSaga, options),
    takeLatest(FORGOT_PASSWORD_VERIFY, forgotPasswordVerifySaga, options),
  ]);
};
